import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection } from '@components'
import './WealthManagement.scss'
import { CreditCardAPI, WealthManagementAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import HeaderSection from '../../../common/components/Header/HeaderSection'
import LandingCardBox from '../../../common/components/LandingCardBox'
import { TitleComponent } from '../../../common/components/TitleComponent'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const WealthManagementContainer = styled.div`
  background-color: #f9f9f9;
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const WealthManagement = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    setisLoading(true)
    loadShortDescData()
  }, [])

  const loadData = async function () {
    const reportData = await WealthManagementAPI('')
    setdata(reportData.data.data)
  }

  const loadShortDescData = async () => {
    const { data } = await ShortDescriptionAPI({ loc: 'wealth_management' })
    setShortDesc(data.data ? data.data[0] : {})
    setisLoading(false)
    loadData()
  }
  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <HeaderSection
          title={shortDesc.title}
          group={t('solusi_masa_depan_anda')}
          description={shortDesc.description}
          banner={shortDesc.banner}
        />
      </Container>

      <WealthManagementContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="pt-4 px-3 pb-0">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              <div className="row">
                <div className="col-12">
                  <h4>{t('pilih_wealth_management')}</h4>
                </div>
              </div>
              <div className="row mt-2">
                {data.map((item) => {
                  return (
                    <div className="col-lg-4">
                      <Desktop>
                        <LandingCardBox
                          title={item.title}
                          image={item.imageBannerDesktop}
                          redirectUrl={'/wealth-management/' + item.id}
                        />
                      </Desktop>
                      <Mobile>
                        <LandingCardBox
                          title={item.title}
                          image={item.imageBannerMobile}
                          redirectUrl={'/wealth-management/' + item.id}
                        />
                      </Mobile>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </WealthManagementContainer>
      <FooterSection currentPage={t('wealth_management')} />
    </div>
  )
}

export default WealthManagement
